import React, { createContext, useContext, useState } from 'react'
import AccountSettings from './AccountSettings'

const AccountSettingsContext = createContext(null)

export function AccountSettingsProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)

  const openSettings = () => setIsOpen(true)
  const closeSettings = () => setIsOpen(false)

  return (
    <AccountSettingsContext.Provider value={{ openSettings, closeSettings }}>
      {children}
      <AccountSettings isOpen={isOpen} onClose={closeSettings} />
    </AccountSettingsContext.Provider>
  )
}

export function useAccountSettings() {
  const ctx = useContext(AccountSettingsContext)
  return ctx || { openSettings: () => {}, closeSettings: () => {} }
}
